"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentPlanTag = exports.BestValueTag = exports.Tag = exports.Price = exports.PlanName = exports.Radio = exports.CustomRadio = exports.PlanItem = exports.TitleContainer = exports.PlanSelectorContainer = exports.ComponentContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const utils_1 = require("../../utils");
const text_1 = require("../text");
const themed_text_1 = require("../themed-text");
exports.ComponentContainer = styled_components_1.default.div `
  width: 100%;
`;
exports.PlanSelectorContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  ${({ deviceType }) => (0, utils_1.isMobile)(deviceType)
    ? `
    flex-direction: column;
    gap: 20px;
  `
    : `
    flex-direction: row;
    gap: 16px;  
  `}
`;
exports.TitleContainer = styled_components_1.default.div `
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
`;
exports.PlanItem = styled_components_1.default.label `
  border: 2px ${monera_app_core_1.Gray_1200} solid;
  border-radius: 10px;
  background-color: white;
  padding: 16px;
  display: grid;
  align-items: center;
  cursor: pointer;
  ${({ deviceType }) => (0, utils_1.isMobile)(deviceType)
    ? `
    grid-template-areas:
      'radioAndName priceAndTag';
  `
    : `
    height: 144px;
    width: 100%;
    row-gap: 30px;
    grid-template-areas: 
      'radioAndName'
      'priceAndTag';
  `}
`;
exports.CustomRadio = styled_components_1.default.span `
  display: ${(props) => (props.visible ? 'block' : 'none')};
  grid-area: radio;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 960px;
  background-color: white;
  border: 2px solid ${monera_app_core_1.Blue_400};
  transition: border-color 0.2s ease 0s, border-width 0.2s ease 0s;
`;
exports.Radio = styled_components_1.default.input `
  grid-area: radio;
  cursor: pointer;
  display: none;

  &:hover + ${exports.CustomRadio} {
    background: #ccc;
  }

  &:checked + ${exports.CustomRadio} {
    border-width: 8px;
    border-color: ${monera_app_core_1.Blue_400};
  }
`;
exports.PlanName = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  grid-area: planName;

  ${({ deviceType }) => (0, utils_1.isMobile)(deviceType)
    ? `
    font-size: 20px;
  `
    : `
    font-size: 14px;  
  `}
`;
exports.Price = (0, styled_components_1.default)(text_1.Text) `
  grid-area: price;
  font-weight: normal;
  width: auto;
  & > sup {
    font-size: 16px;
    top: -14px;
    position: relative;
  }
  & > p1 {
    font-size: 38px;
  }
  & > p2 {
    font-size: 16px;
    line-height: 24px;
  }

  ${({ deviceType }) => (0, utils_1.isMobile)(deviceType)
    ? `
      justify-self: end;
  `
    : `
      justify-self: start;
  `}
`;
exports.Tag = (0, styled_components_1.default)(text_1.Text) `
  grid-area: tag;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  text-align: center;
  padding: 3px 13px;
  width: fit-content;
  ${({ deviceType, visible }) => (0, utils_1.isMobile)(deviceType)
    ? `
    margin-top: 8px;
    justify-self: end;
    display: ${visible ? 'block' : 'none'};
  `
    : `
    position: relative;
    bottom: -28px;
    justify-self: center;
    visibility: ${visible ? 'visible' : 'hidden'};
  `}
`;
exports.BestValueTag = (0, styled_components_1.default)(exports.Tag) `
  background-color: #1a98ff;
  color: white;
`;
exports.CurrentPlanTag = (0, styled_components_1.default)(exports.Tag) `
  background-color: black;
  color: white;
`;
